module.exports = "/static/assets/b8aa30bdb0ca4194176b70d440295b3f.gif";